import { invariantResponse } from '@epic-web/invariant'
import { data, redirect } from 'react-router'
import { GeneralErrorBoundary } from '#app/components/error-boundary.tsx'
import { prisma } from '#app/utils/db.server.ts'
import { type Route } from './+types/$date_.edit.ts'
import { ScheduleEditor } from './__schedules-editor.tsx'

export { action } from './__schedules-editor.server.tsx'

export async function loader({ params }: Route.LoaderArgs) {
	if (!params?.date) {
		return redirect('/schedules')
	}

	const schedule = await prisma.schedule.findFirst({
		select: {
			id: true,
			date: true,
			deadline: true,
			source: true,
			costPerHour: true,
		},
		where: { date: params.date },
	})

	invariantResponse(schedule, `Schedule not found for ${params.date}`, {
		status: 404,
	})

	console.log({ schedule })
	return data({ schedule })
}

export default function ScheduleEdit({
	loaderData: { schedule },
}: Route.ComponentProps) {
	return <ScheduleEditor schedule={schedule} />
}

export const meta: Route.MetaFunction = ({ params }) => {
	return [
		{ title: `Irrigation Schedules | ${params.date}` },
		{
			name: 'description',
			content: `Clearwater Farms 1 Irrigation Schedules`,
		},
	]
}

export function ErrorBoundary() {
	return (
		<GeneralErrorBoundary
			statusHandlers={{
				404: ({ params }) => <p>No schedule exists for "{params.date}" </p>,
			}}
		/>
	)
}
